'use client';
import { useTranslation } from 'react-i18next';

export default function ProviderDescription({ provider }) {
  const { t } = useTranslation();
  const { pitchTitle = '', pitchText = '', help = '' } = provider;

  return (
    <div className="flex flex-col gap-6">
      <h4 className="p-0 m-0 text-lg font-normal text-[#1f384c]">
        {pitchTitle}
      </h4>
      <span className="text-[#53565a] text-base font-thin leading-7 whitespace-pre-line break-words inline-block">
        {pitchText}
      </span>
      <span className="text-[#53565a] text-base font-thin leading-7 whitespace-pre-line break-words inline-block">
        {help}
      </span>
    </div>
  );
}
